export default class MemberDesignationsJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(this.jwtConfig.main.memberDesignationsEndpoint, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberDesignationsEndpoint}/${id}`, payload)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.memberDesignationsEndpoint}/${id}`)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.memberDesignationsEndpoint, {
      params
    })
  }
}
